// Module
var code = "<p>Pour participer à notre tirage au sort</p> <p>INSCRIVEZ-VOUS !</p>";
// Exports
module.exports = code;